var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.currentRoute,attrs:{"id":"app"}},[(_vm.appLoaded)?_c('div',[_c('Menu'),_c('section',{attrs:{"id":"content"}},[_c('router-view')],1)],1):_c('loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }